module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-1139-min.1aa83510.jpg";